export default __webpack_public_path__ + "static/media/doubleQuote.7d7fe453.svg";